<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">{{ model.title }}</h4>
    </div>
    <div class="modal-body">
      <div>{{ model.content }}</div>
    </div>
    <div class="modal-footer justify-content-center">
      <button type="button"
              class="btn btn-default"
              @click="closeModal">Annuler</button>
      <button type="button"
              class="btn btn-danger"
              @click="onConfirm">Oui, confirmer</button>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'

  export default {
    data: () => ({
      store
    }),

    computed: {
      model () {
        return store.modal.dataModel
      }
    },

    methods: {
      onConfirm () {
        this.$bus.$emit(`${this.model.type}-confirm-success`)
        this.closeModal();
      }
    }
  }
</script>
